import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Classes.css';
import API_URL from '../../api/ExamCalendarApi';

const Classes = () => {
    const [classes, setClasses] = useState([]);
    const [title, setTitle] = useState('');
    const [videolink, setVideolink] = useState('');
    const [photo, setPhoto] = useState(null);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    const [currentClassId, setCurrentClassId] = useState(null);

    useEffect(() => {
        fetchClasses();
    }, []);

    const fetchClasses = async () => {
        try {
            const response = await axios.get(`${API_URL}/homepage/classes`);
            setClasses(response.data.classes);
        } catch (error) {
            console.error('Error fetching classes:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title || !videolink) {
            setError('Title and Video link are required');
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('videolink', videolink);
        if (photo) formData.append('photo', photo);

        try {
            if (updateMode) {
                await axios.put(`${API_URL}/homepage/update-class/${currentClassId}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                setSuccessMessage('Class updated successfully');
            } else {
                await axios.post(`${API_URL}/homepage/add-class`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                setSuccessMessage('Class added successfully');
            }

            setTitle('');
            setVideolink('');
            setPhoto(null);
            setUpdateMode(false);
            fetchClasses();
        } catch (error) {
            setError('Error saving class');
            setSuccessMessage('');
        }
    };

    const handleDelete = async (classId) => {
        try {
            await axios.delete(`${API_URL}/homepage/delete-class/${classId}`);
            setSuccessMessage('Class deleted successfully');
            fetchClasses();
        } catch (error) {
            setError('Error deleting class');
        }
    };

    const handleEdit = (classItem) => {
        setTitle(classItem.title);
        setVideolink(classItem.videolink);
        setPhoto(null);
        setCurrentClassId(classItem._id);
        setUpdateMode(true);
    };

    return (
        <div className="admin-classes-container">
            <h2 className="admin-classes-heading">Manage Classes</h2>

            {error && <div className="admin-classes-alert admin-classes-error">{error}</div>}
            {successMessage && <div className="admin-classes-alert admin-classes-success">{successMessage}</div>}

            <form onSubmit={handleSubmit} className="admin-classes-form">
                <div className="admin-classes-form-group">
                    <label htmlFor="title" className="admin-classes-label">Class Title</label>
                    <input
                        type="text"
                        id="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="admin-classes-input"
                        required
                    />
                </div>

                <div className="admin-classes-form-group">
                    <label htmlFor="videolink" className="admin-classes-label">Video Link</label>
                    <input
                        type="text"
                        id="videolink"
                        value={videolink}
                        onChange={(e) => setVideolink(e.target.value)}
                        className="admin-classes-input"
                        required
                    />
                </div>

                <div className="admin-classes-form-group">
                    <label htmlFor="photo" className="admin-classes-label">Class Photo</label>
                    <input
                        type="file"
                        id="photo"
                        onChange={(e) => setPhoto(e.target.files[0])}
                        className="admin-classes-input"
                    />
                </div>

                <button type="submit" className="admin-classes-button">
                    {updateMode ? 'Update' : 'Add'} Class
                </button>
            </form>

            <h3 className="admin-classes-subheading">Class List</h3>
            <div className="admin-classes-table-wrapper">
            <table className="admin-classes-table">
                <thead>
                    <tr>
                        <th className="admin-classes-th">Title</th>
                        <th className="admin-classes-th">Video Link</th>
                        <th className="admin-classes-th">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {classes.map((classItem) => (
                        <tr key={classItem._id} className="admin-classes-tr">
                            <td className="admin-classes-td">{classItem.title}</td>
                            <td className="admin-classes-td">{classItem.videolink}</td>
                            <td className="admin-classes-td">
                                <button
                                    onClick={() => handleEdit(classItem)}
                                    className="admin-classes-button admin-classes-edit"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(classItem._id)}
                                    className="admin-classes-button admin-classes-delete"
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default Classes;